
import { Options, Vue } from 'vue-class-component'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { useStore } from '@/store'
import { hashData } from '@/utils/hash-data'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronUp, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';

library.add(faChevronUp, faChevronDown, faChevronRight)

@Options({
  components: {
    FontAwesomeIcon,
    QSkeleton,
  },
  computed: {
    isLoadingPoints() {
      return this.$store.state.app.isLoadingPoints
    },
  }
})
export default class ClubcardOnline extends Vue {
  store = useStore()
  openRewards = false

  isFirstAccess() {
    const query = this.$route?.query

    return query && query['is-first-linking'] === 'true'
  }

  updateCustomer() {
    this.updateGAEvent('mylotuss_update_account')
    location.href = process.env.VUE_APP_UPDATE_ACCOUNT!
  }

  updateGAEvent(txtEvent: string) {
    const userId = this.store.state.lineInfo?.profile?.userId
    const customerType = this.store.state.customer?.customerType
    addGAEvent({
      event: txtEvent,
      scope: customerType,
      loyalty_Info_complete: userId || customerType ? true : false,
      customer_type: customerType,
      phone_hash: hashData(this.store.state.customer?.phoneNumber as string),
      surrogate_id: userId,
    })
  }
}
